export default __webpack_public_path__ + "static/media/nfo-banner-it-telecom-comp.87a5fc2f.jpg";